import React from "react";
import track from "react-tracking";

import Scenarios from "../components/Scenario/ScenarioMain";

const Scenario_Page = () => {
	return (
		<>
			{/* ScenarioMain has pageMode="edit" by default 
			- access controle will be managed by user roles */}
			<Scenarios />
		</>
	);
};

export const Scenario = track(
	{ page: "Scenario" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) }
)(Scenario_Page);
